const About = () => {
  return (
    <div className="container mx-auto px-4 py-16">
      <h1 className="text-3xl lg:text-4xl font-bold mb-6 text-white">Sobre Nós</h1>
      <p className="text-lg text-neutral-300 mb-4">
        Bem-vindo ao MovieApp! Somos uma plataforma dedicada a fornecer informações detalhadas sobre filmes e séries de TV. Nosso objetivo é ajudar os entusiastas do cinema a descobrir novos conteúdos e se manterem atualizados com as últimas tendências do mundo do entretenimento.
      </p>
      <p className="text-lg text-neutral-300 mb-4">
        Nossa equipe é composta por apaixonados por cinema e tecnologia, trabalhando juntos para criar uma experiência de usuário intuitiva e informativa. Acreditamos que o cinema é uma forma poderosa de arte que pode inspirar, educar e entreter pessoas de todas as idades.
      </p>
      <p className="text-lg text-neutral-300 mb-4">
        No MovieApp, você encontrará uma vasta coleção de filmes e séries, com informações detalhadas sobre elenco, sinopse, avaliações e muito mais. Estamos constantemente atualizando nosso banco de dados para garantir que você tenha acesso às informações mais recentes.
      </p>
      <p className="text-lg text-neutral-300 mb-4">
        Obrigado por escolher o MovieApp como sua fonte de informações sobre filmes e séries. Esperamos que você aproveite sua experiência em nossa plataforma!
      </p>
    </div>
  );
};

export default About;